import { createElement, ReactElement, ReactNode } from "react";
import { loadScriptAsync } from "../Utils";
import HardwareScannerPreview from "./Components/HardwareScannerPreview";
import { IScanner, IScannerCode, IScanOptions } from "./Abstraction/IScanner";
import { delayAsync } from "./Utils";


export class KeyboardScanner implements IScanner {


    protected _curScanResult: (result: IScannerCode) => void;
    protected _input: HTMLElement;
    protected _codeResolve: (code: IScannerCode) => void;
    protected _curCode: string;

    constructor() {
        this.isScanning = false;
        this.isOpen = false;

        document.body.addEventListener("keypress", ev => this.onKeyPress(ev));
    }

    /**************************************/

    async closeAsync() {

        await this.stopScanAsync();

        if (this._input)
            this._input.remove();

        this.isOpen = false;
    }

    /**************************************/

    async openAsync(force = false): Promise<void> {

        if (!this._input) {
            this._input = document.createElement("div");
            this._input.tabIndex = 1;
            this._input.style.opacity = "0";
            this._input.style.width = "0px";
            this._input.style.height = "0px";

            this._input.addEventListener("blur", ev => {
                if (this.isScanning)
                    this._input.focus();
            });
        }

        document.body.appendChild(this._input);
        this.isOpen = true;
    }

    /**************************************/

    protected onKeyPress(ev: KeyboardEvent) {

        if (!this.isScanning)
            return;

        if (ev.key == "Enter") {

            if (this._codeResolve) {
                this._codeResolve({
                    code: this._curCode,
                    type: ""
                });

                this._curCode = "";
                this._codeResolve = null;
            }

        }
        else {
            this._curCode += ev.key;
        }

        console.log(ev.key, ev.key.charCodeAt(0));
    }


    /**************************************/

    async scanSingleAsync(options?: IScanOptions): Promise<IScannerCode | null> {

        this.isScanning = true;
        this._curCode = "";
        await delayAsync(0);
        this._input.focus();
        return new Promise<IScannerCode>((res, _) => this._codeResolve = res);
    }

    /**************************************/

    async stopScanAsync(): Promise<void> {

        if (this._codeResolve) {
            this._codeResolve(null);
            this._codeResolve = null;
        }
        this.isScanning = false;
    }


    /**************************************/

    createPreview(info?: ReactNode, isScanning?: boolean, lastScanTime?: Date): ReactElement {
        return createElement(HardwareScannerPreview, { scanner: this, info, isScanning, lastScanTime });
    }

    /**************************************/

    isScanning: boolean;

    isOpen: boolean;
}